import { CONTACT_POINT_SYSTEM, REGEX_EXPS } from "utils/constants";
import {
  getPhonePrefixFromYupContext,
  isValidLocalPhoneNumber,
} from "utils/helpers/phone";
import * as yup from "yup";

const validation = (errors) => {
  return yup.object().shape({
    telecoms: yup.object().shape({
      [CONTACT_POINT_SYSTEM.EMAIL]: yup.object().shape({
        value: yup
          .string()
          .nullable()
          .email(errors.EMAIL)
          .required(errors.REQUIRED),
      }),
      [CONTACT_POINT_SYSTEM.PHONE]: yup.object().shape({
        value: yup
          .string()
          .typeError(errors.REQUIRED)
          .required(errors.REQUIRED)
          .test("isValid", errors.INVALID_VALUE, async function (value) {
            const prefix = getPhonePrefixFromYupContext(this);
            return isValidLocalPhoneNumber(
              String(value || "").replace(/\s+/g, ""),
              prefix,
            );
          }),
      }),
    }),
    acceptContact: yup.boolean().oneOf([true]).required(),
  });
};

export default validation;
